const imagePath = {
  install(Vue, options) {
    Vue.prototype.$getImagePath = (path, image) => {
      // Get the physical image path
      let imgSrc = path + '/' + image
      return require('@/assets/' + imgSrc)
    }
  }
};

// Usage example:
// {{ $getImagePath('images', 'icon_facebook.svg') }}
export default imagePath;



// WEBPACK FOOTER //
// ./src/plugins/imagepath.js